import { Routes, Route, Navigate } from 'react-router-dom'
import Login from '@/views/pages/login/index.page'

const UnAuthorizedApp = () => {
  return (
    <Routes>
      <Route path="*" element={<Login />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default UnAuthorizedApp
